import { AdapterDateFns } from '@mui/x-date-pickers/AdapterDateFns';
import { LocalizationProvider as MuiLocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';

import { useCurrentUser } from 'src/api/user.api';
import { useAuthContext } from 'src/auth/hooks';
import { useLocales } from './use-locales';

import { useEffect } from 'react';
import { useTranslation } from 'react-i18next';

// ----------------------------------------------------------------------

type Props = {
  children: React.ReactNode;
};

export default function LocalizationProvider({ children }: Props) {
  const { currentLang } = useLocales();
  const { i18n } = useTranslation();

  const { isAuthenticated } = useAuthContext();
  const { data: currentUser } = useCurrentUser(isAuthenticated);

  // check user lang vs locale lang
  useEffect(() => {
    if (
      isAuthenticated &&
      currentLang.value &&
      currentUser &&
      currentUser.language &&
      currentLang.value !== currentUser.language
    ) {
      // if backend lang different than local, we use backend lang
      void i18n.changeLanguage(currentUser.language);
    }
  }, [currentLang.value, currentUser, i18n, isAuthenticated]);

  return (
    <MuiLocalizationProvider
      dateAdapter={AdapterDateFns}
      adapterLocale={currentLang.adapterLocale}
    >
      {children}
    </MuiLocalizationProvider>
  );
}
